import { Route, Routes } from 'react-router-dom';
import CollectionsListView from './CollectionsListView';
import CollectionDetailsView from './CollectionDetailsView';

export default function CollectionsView() {
  return (
    <Routes>
      <Route index element={<CollectionsListView />} />
      <Route path=":id" element={<CollectionDetailsView />} />
    </Routes>
  );
}
